import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doc-type-badge" }

import { computed } from 'vue'

import { docTypeLabel } from '@/models/doc'
import type { DocType } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocTypeBadge',
  props: {
    docType: {}
  },
  setup(__props: any) {

const props = __props

const label = computed(() => {
  const docType =
    props.docType === 'podcast_episode' ? 'podcast' : props.docType
  return docTypeLabel[docType].singularCap
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(label.value), 1))
}
}

})